import { useState, useEffect } from 'react';

import { HashLink as Link } from 'react-router-hash-link';
import { up } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';

import { SVGAsset } from 'components/atoms/SVGAsset';

import {
    StyledModalAnchor,
    ContentWrapper,
    AnchorsWrapper,
    AnchorButton,
    AnchorTitle,
    MobileButton,
    MobileButtonTitle,
    ModalButton,
    ModalButtonTitle,
    StyledBackgroundAnchor,
} from './ModalAnchor.styled';
import type { ModalAnchorProps } from './types';

export type AnchorPropsMobile = {
    title?: string;
    anchor?: string;
    setVisible: () => void;
};

export const Anchor = (props: AnchorPropsMobile): JSX.Element => {
    const { title, anchor, setVisible } = props;

    return (
        <Link to={`#${anchor}`} onClick={() => setVisible()}>
            <AnchorButton>
                <AnchorTitle>{title}</AnchorTitle>
            </AnchorButton>
        </Link>
    );
};

export const ModalAnchor = (props: ModalAnchorProps): JSX.Element => {
    const { anchors } = props;

    const [visible, setVisible] = useState<boolean>(false);

    const anchorsList: JSX.Element[] = [];
    anchors?.forEach((el, index: number) => {
        if (el.component === 'section') {
            anchorsList.push(
                <Anchor
                    setVisible={() => setVisible(false)}
                    key={index}
                    title={el.props?.sectionTitle}
                    // eslint-disable-next-line no-underscore-dangle
                    anchor={el._key}
                />
            );
        }
    });

    const phone = useBreakpoint(up('lg'));
    useEffect(() => {
        setVisible(false);
    }, [phone]);

    return (
        <>
            <MobileButton onClick={() => setVisible(true)}>
                <MobileButtonTitle>Содержание</MobileButtonTitle>
                <SVGAsset src="icons.24px.chevron" />
            </MobileButton>

            <StyledBackgroundAnchor visible={visible} />

            <StyledModalAnchor
                visible={visible}
                onClick={() => setVisible(false)}
            >
                <ContentWrapper>
                    <ModalButton onClick={() => setVisible(false)}>
                        <ModalButtonTitle>Содержание</ModalButtonTitle>
                        <SVGAsset src="icons.24px.closeX" />
                    </ModalButton>

                    {anchorsList.length > 1 ? (
                        <AnchorsWrapper>{anchorsList}</AnchorsWrapper>
                    ) : undefined}
                </ContentWrapper>
            </StyledModalAnchor>
        </>
    );
};
